<div class="kpi-page">
  <div class="title">
    <p class="vox-heading-2" translate>kpi.title</p>
  </div>
  <hr />
  <form [formGroup]="dataForm" class="form-container">
    <div class="row">
      <div class="col-12 col-md-5">
        <label for="kpi-month" translate>kpi.form.kpi-month.label</label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': isInvalid('kpiMonth')}">
          <input class="vox-text-field" type="text" id="kpi-month"
            placeholder="{{ 'kpi.form.kpi-month.placeholder' | translate }}" formControlName="kpiMonth" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <label for="kpi-year" translate>kpi.form.kpi-year.label</label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': isInvalid('kpiYear')}">
          <input class="vox-text-field" type="number" id="kpi-year"
            placeholder="{{ 'kpi.form.kpi-year.placeholder' | translate }}" formControlName="kpiYear" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-5">
        <label for="total-customers" translate>kpi.form.total-customers.label</label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': isInvalid('totalCustomers')}">
          <input class="vox-text-field" type="number" id="total-customers"
            placeholder="{{ 'kpi.form.total-customers.placeholder' | translate }}" formControlName="totalCustomers" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <label for="paid-subscription-churn" translate>kpi.form.paid-subscription-churn.label</label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': isInvalid('paidSubscriptionChurn')}">
          <input class="vox-text-field" type="number" id="paid-subscription-churn"
            placeholder="{{ 'kpi.form.paid-subscription-churn.placeholder' | translate }}"
            formControlName="paidSubscriptionChurn" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-5">
        <label for="mrr" translate>kpi.form.mrr.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{'vox-input-group_invalid': isInvalid('mrr')}">
          <input class="vox-text-field" type="number" id="mrr"
            placeholder="{{ 'kpi.form.mrr.placeholder' | translate }}" formControlName="mrr" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <label for="mrr-growth" translate>kpi.form.mrr-growth.label</label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': isInvalid('mrrGrowth')}">
          <input class="vox-text-field" type="number" id="mrr-growth"
            placeholder="{{ 'kpi.form.mrr-growth.placeholder' | translate }}" formControlName="mrrGrowth" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
    </div>
    <div formGroupName="newCustomers" class="row">
      <div class="col-12 col-md-5">
        <label for="new-customers-current">{{'kpi.form.new-customers-current.label' |
          translate}} <span class="vox-chip vox-chip_royal-blue-text">{{'kpi.form.labels.current' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': newCustomers.errors?.current}">
          <input class="vox-text-field" type="number" id="new-customers-current"
            placeholder="{{ 'kpi.form.new-customers-current.placeholder' | translate }}" formControlName="current" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <label for="new-customers-goal">{{'kpi.form.new-customers-goal.label' |
          translate}} <span class="vox-chip vox-chip_bright-crimson-text">{{'kpi.form.labels.goal' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': newCustomers.errors?.goal}">
          <input class="vox-text-field" type="number" id="new-customers-goal"
            placeholder="{{ 'kpi.form.new-customers-goal.placeholder' | translate }}" formControlName="goal" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
    </div>
    <div formGroupName="itaNewMrrDirect" class="row">
      <div class="col-12 col-md-5">
        <label for="ita-new-mrr-direct-current"><span title="Italy (Italia)"
            class="flag flag-select flag-icon flag-icon-it"></span> {{'kpi.form.ita-new-mrr-direct-current.label' |
          translate}} <span class="vox-chip vox-chip_royal-blue-text">{{'kpi.form.labels.current' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': itaNewMrrDirect.errors?.current}">
          <input class="vox-text-field" type="number" id="ita-new-mrr-direct-current"
            placeholder="{{ 'kpi.form.ita-new-mrr-direct-current.placeholder' | translate }}"
            formControlName="current" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <label for="ita-new-mrr-direct-goal"><span title="Italy (Italia)"
            class="flag flag-select flag-icon flag-icon-it"></span> {{'kpi.form.ita-new-mrr-direct-goal.label' |
          translate}} <span class="vox-chip vox-chip_bright-crimson-text">{{'kpi.form.labels.goal' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': itaNewMrrDirect.errors?.goal}">
          <input class="vox-text-field" type="number" id="ita-new-mrr-direct-goal"
            placeholder="{{ 'kpi.form.ita-new-mrr-direct-goal.placeholder' | translate }}" formControlName="goal" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
    </div>
    <div formGroupName="itaNewMrrIndirect" class="row">
      <div class="col-12 col-md-5">
        <label for="ita-new-mrr-indirect-current"><span title="Italy (Italia)"
            class="flag flag-select flag-icon flag-icon-it"></span> {{'kpi.form.ita-new-mrr-indirect-current.label' |
          translate}} <span class="vox-chip vox-chip_royal-blue-text">{{'kpi.form.labels.current' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': itaNewMrrIndirect.errors?.current}">
          <input class="vox-text-field" type="number" id="ita-new-mrr-indirect-current"
            placeholder="{{ 'kpi.form.ita-new-mrr-indirect-current.placeholder' | translate }}"
            formControlName="current" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <label for="ita-new-mrr-indirect-goal"><span title="Italy (Italia)"
            class="flag flag-select flag-icon flag-icon-it"></span> {{'kpi.form.ita-new-mrr-indirect-goal.label' |
          translate}} <span class="vox-chip vox-chip_bright-crimson-text">{{'kpi.form.labels.goal' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': itaNewMrrIndirect.errors?.goal}">
          <input class="vox-text-field" type="number" id="ita-new-mrr-indirect-goal"
            placeholder="{{ 'kpi.form.ita-new-mrr-indirect-goal.placeholder' | translate }}" formControlName="goal" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
    </div>
    <!-- <div formGroupName="ukNewMrrDirect" class="row">
      <div class="col-12 col-md-5">
        <label for="uk-new-mrr-direct-current"><span title="UK (United Kingdom)"
            class="flag flag-select flag-icon flag-icon-gb"></span> {{'kpi.form.uk-new-mrr-direct-current.label' |
          translate}} <span class="vox-chip vox-chip_royal-blue-text">{{'kpi.form.labels.current' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': ukNewMrrDirect.errors?.current}">
          <input class="vox-text-field" type="number" id="uk-new-mrr-direct-current"
            placeholder="{{ 'kpi.form.uk-new-mrr-direct-current.placeholder' | translate }}"
            formControlName="current" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <label for="uk-new-mrr-direct-goal"><span title="UK (United Kingdom)"
            class="flag flag-select flag-icon flag-icon-gb"></span> {{'kpi.form.uk-new-mrr-direct-goal.label' |
          translate}} <span class="vox-chip vox-chip_bright-crimson-text">{{'kpi.form.labels.goal' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': ukNewMrrDirect.errors?.goal}">
          <input class="vox-text-field" type="number" id="uk-new-mrr-direct-goal"
            placeholder="{{ 'kpi.form.uk-new-mrr-direct-goal.placeholder' | translate }}" formControlName="goal" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
    </div>
    <div formGroupName="usaNewMrrDirect" class="row">
      <div class="col-12 col-md-5">
        <label for="usa-new-mrr-direct-current"><span title="USA (United States of America)"
            class="flag flag-select flag-icon flag-icon-us"></span> {{'kpi.form.usa-new-mrr-direct-current.label' |
          translate}} <span class="vox-chip vox-chip_royal-blue-text">{{'kpi.form.labels.current' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': usaNewMrrDirect.errors?.current}">
          <input class="vox-text-field" type="number" id="usa-new-mrr-direct-current"
            placeholder="{{ 'kpi.form.usa-new-mrr-direct-current.placeholder' | translate }}"
            formControlName="current" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <label for="usa-new-mrr-direct-goal"><span title="USA (United States of America)"
            class="flag flag-select flag-icon flag-icon-us"></span> {{'kpi.form.usa-new-mrr-direct-goal.label' |
          translate}} <span class="vox-chip vox-chip_bright-crimson-text">{{'kpi.form.labels.goal' |
            translate}}</span></label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': usaNewMrrDirect.errors?.goal}">
          <input class="vox-text-field" type="number" id="usa-new-mrr-direct-goal"
            placeholder="{{ 'kpi.form.usa-new-mrr-direct-goal.placeholder' | translate }}" formControlName="goal" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>kpi.form.error</span>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-12 col-md-10">
        <label for="quote" translate>kpi.form.quote.label</label>
        <div class="vox-input-group vox-input-group_dense">
          <textarea class="vox-text-field" id="quote" placeholder="{{ 'kpi.form.quote.placeholder' | translate }}"
            formControlName="quote"></textarea>
        </div>
      </div>
    </div>
    <div class="submit-container">
      <button (click)="generateKPI()" class="vox-btn vox-btn-primary" type="button" [disabled]="dataForm.invalid"
        translate>
        kpi.form.buttons.generate
      </button>
      <button (click)="sendKPIEmail()" class="vox-btn vox-btn-primary" type="button" [disabled]="dataForm.invalid"
        [ladda]="loading">
        {{'kpi.form.buttons.send-email' | translate}}
      </button>
    </div>
  </form>
  <div class="preview-container">
    <div class="row">
      <div class="preview-container__top col-12">
        <h3 translate>kpi.preview.title</h3>
      </div>
      <div class="preview-container__bottom col-12">
        <div class="preview-container__table" [innerHtml]="safeEmailTemplate">
        </div>
      </div>
    </div>
  </div>
</div>